export const filterLabels = {
  active: "accountStatus",
  "defaultAccount:activePoints": "activeUnitSingularOrPlural",
  "address:address1": "address1",
  "address:address2": "address2",
  agreement1: "agreement1",
  agreement2: "agreement2",
  agreement3: "agreement3",
  amountExcludedForLevel: "amountExcludedForTier",
  averageTransactionAmount: "avgTransactionValueWithCurrency",
  "address:city": "city",
  "address:country": "country",
  createdAt: "createdOn",
  birthDate: "dateOfBirth",
  email: "email",
  firstName: "firstName",
  firstTransactionDate: "firstTransactionDate",
  gender: "gender",
  referralToken: "referralToken",
  lastName: "lastName",
  lastTransactionDate: "lastTransactionDate",
  loyaltyCardNumber: "loyaltyCardNumber",
  manuallyAssignedLevelId: "manuallyAssignedTier",
  customerId: "memberID",
  phone: "phoneNumber",
  "address:postal": "postalCode",
  "address:province": "province",
  "address:street": "street",
  levelAchievementDate: "tierFromDefaultTierSetReachedDate",
  levelId: "tierName",
  "defaultAccount:earnedPoints": "totalEarnedUnits",
  transactionsAmount: "transactionsAmount",
  transactionsAmountWithoutDeliveryCosts:
    "transactionsAmountWithoutDeliveryCosts",
  transactionsCount: "transactionsCount",
  updatedAt: "updatedAt",
  registeredAt: "registrationDate",
  labels: "customAttributes",
};

export const memberFilterLabelsList = Object.keys(filterLabels).map((key) => ({
  id: key,
  label: filterLabels[key as keyof typeof filterLabels],
}));
